
export const Endereco = {
    id : 1,
    endereco : "Rod. Francisco Magno Vieira, 832 - Rio Tavares, Florianópolis - SC, 88063-700",
    link : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d910261.4505927326!2d-49.4511885421362!3d-26.976119749584235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95273bf7fc6631ad%3A0x7e90bf5cbf778f35!2sGR%20Select%20Seminovos!5e0!3m2!1spt-BR!2sbr!4v1709063534635!5m2!1spt-BR!2sbr'
}